import { render, staticRenderFns } from "./ManuscriptDialog.vue?vue&type=template&id=4b38de4a&scoped=true"
import script from "./ManuscriptDialog.vue?vue&type=script&lang=js"
export * from "./ManuscriptDialog.vue?vue&type=script&lang=js"
import style0 from "./ManuscriptDialog.vue?vue&type=style&index=0&id=4b38de4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b38de4a",
  null
  
)

export default component.exports